import { render, staticRenderFns } from "./tablist4.vue?vue&type=template&id=744b8f7e&scoped=true&"
import script from "./tablist4.vue?vue&type=script&lang=js&"
export * from "./tablist4.vue?vue&type=script&lang=js&"
import style0 from "./tablist4.vue?vue&type=style&index=0&id=744b8f7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b8f7e",
  null
  
)

export default component.exports